var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.9,4.6l-3-3c-0.2-0.2-0.5-0.2-0.7,0C4,1.9,4,2.2,4.2,2.4l3,3c0.2,0.2,0.5,0.2,0.7,0C8.1,5.1,8.1,4.8,7.9,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,21c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5C23.8,20.5,24,20.7,24,21L24,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,22.5c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h0C22.3,22,22.5,22.2,22.5,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,24c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h0C20.8,23.5,21,23.7,21,24L21,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,25.5c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h0C19.3,25,19.5,25.2,19.5,25.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 27,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 27,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 27,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,27c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h0C19.8,26.5,20,26.7,20,27L20,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,27c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h0C17.8,26.5,18,26.7,18,27L18,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,21c0,0.3-0.2,0.5-0.5,0.5S6,21.3,6,21c0-0.3,0.2-0.5,0.5-0.5h0C6.8,20.5,7,20.7,7,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,22.5C8.5,22.8,8.3,23,8,23c-0.3,0-0.5-0.2-0.5-0.5C7.5,22.2,7.7,22,8,22h0C8.3,22,8.5,22.2,8.5,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,24c0,0.3-0.2,0.5-0.5,0.5S9,24.3,9,24s0.2-0.5,0.5-0.5l0,0C9.8,23.5,10,23.7,10,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,25.5c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h0C11.3,25,11.5,25.2,11.5,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,27c0,0.3-0.2,0.5-0.5,0.5S4,27.3,4,27c0-0.3,0.2-0.5,0.5-0.5h0C4.8,26.5,5,26.7,5,27L5,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,27c0,0.3-0.2,0.5-0.5,0.5C6.2,27.5,6,27.3,6,27s0.2-0.5,0.5-0.5h0C6.8,26.5,7,26.7,7,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,27c0,0.3-0.2,0.5-0.5,0.5C8.2,27.5,8,27.3,8,27s0.2-0.5,0.5-0.5l0,0C8.8,26.5,9,26.7,9,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,27c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5l0,0C10.8,26.5,11,26.7,11,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,27c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h0C12.8,26.5,13,26.7,13,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,29h-14v-4.1c0.1-0.1,0.2-0.1,0.3-0.2l3.6-4.8l0-0.1l0.1-0.2l0-0.1V17H23c0.6,0,1-0.4,1-1v-1.5c0-0.6-0.4-1-1-1h-0.5 V12H23c0.6,0,1-0.4,1-1V9.5c0-0.6-0.4-1-1-1h-0.5V7h0.4c0.5,0,1-0.2,1.4-0.6l4.8-4.7c0.3-0.3,0.3-0.7,0.2-1.1 C29.1,0.2,28.8,0,28.4,0H1.7C1.3,0,0.9,0.2,0.7,0.6C0.6,1,0.7,1.4,0.9,1.7l4.8,4.7C6.1,6.8,6.6,7,7.1,7h0.4v1.5H7c-0.6,0-1,0.4-1,1 V11c0,0.6,0.4,1,1,1h0.5v1.5H7c-0.6,0-1,0.4-1,1V16c0,0.6,0.4,1,1,1h3.5v2.5l0,0.1l0.1,0.2l0,0.1l3.6,4.8c0.1,0.1,0.2,0.2,0.3,0.2 V29h-14C0.2,29,0,29.2,0,29.5C0,29.8,0.2,30,0.5,30h0h29c0.3,0,0.5-0.2,0.5-0.5C30,29.2,29.8,29,29.5,29L29.5,29z M9.5,11V9.5H12 V11L9.5,11z M13,9.5h4V11h-4V9.5z M18,9.5h2.5V11H18L18,9.5z M23,11h-1.5V9.5H23L23,11z M6.4,5.7L1.7,1l26.7,0l-4.8,4.7 C23.4,5.9,23.2,6,22.9,6H7.1C6.9,6,6.6,5.9,6.4,5.7z M8.5,7h13v1.5h-13L8.5,7z M7,9.5h1.5V11H7L7,9.5z M8.5,12h13v1.5h-13V12z  M7,14.5h16V16H7L7,14.5z M12,20h4.5c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5h-5v-2h7v2.3L15,24h0L12,20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoreshIcon);
export default __webpack_public_path__ + "static/media/boreshIcon.4ddbdf47b47dd0a3dc9c8969feb571f0.svg";
export { ForwardRef as ReactComponent };